import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";

function Breadcrumb({ items }) {
  return (
    <Box display="flex" alignItems="center" mb={2} mt={1} flexWrap="wrap">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        const label = typeof item === "string" ? item : item.label;
        const clickable = typeof item === "object" && typeof item.onClick === "function";

        return (
          <Box key={index} display="flex" alignItems="center">
            <Typography
              variant="body2"
              color={isLast ? "#000000" : clickable ? "textSecondary" : "textSecondary"}
              fontWeight={isLast ? "bold" : "normal"}
              fontSize={16}
              sx={{
                cursor: clickable ? "pointer" : "default",
              }}
              onClick={clickable ? item.onClick : undefined}
            >
              {label}
            </Typography>
            {!isLast && (
              <Typography sx={{ mx: 1, fontSize: 16 }} variant="body2" color="text.secondary">
                /
              </Typography>
            )}
          </Box>
        );
      })}
    </Box>
  );
}

Breadcrumb.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        onClick: PropTypes.func,
      }),
    ])
  ).isRequired,
};

export default Breadcrumb;
